import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchReminders } from 'store/actions';

// Import utilities
import { DrawerRPC } from 'components/utilities';
import useToggle from 'components/utilities/hooks/toggle/useToggle';

// Import icons
import { ReactComponent as RemindersIcon } from 'assets/icons/ic_reminder.svg';

// Import components
import { AuthModal, Button } from 'components/elements';
import { Reminder } from './Reminder';
import { Loader } from 'components/elements';

// Import helpers
import { remindersSorting } from './helpers';

export function Reminders() {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { data: reminders, isLoaded } = useSelector((store) => store.reminders);
	const [open, toggle] = useToggle();

	const handleClick = () => {
		toggle();
		fetchReminders()(dispatch);
	};

	// sort reminders by program start time
	// if some reminders have the same program start time sort them by program title
	const remindersSorted = useMemo(
		() => remindersSorting({ reminders }),
		//eslint-disable-next-line
		[isLoaded]
	);

	return (
		<>
			<AuthModal>
				<Button modifiers={['navIcon']} onClick={handleClick}>
					<RemindersIcon />
				</Button>
			</AuthModal>
			<DrawerRPC
				onClose={toggle}
				title={t('common_reminders_title')}
				isOpen={open}
			>
				{!isLoaded ? (
					<Loader
						zIndex={900}
						position="relative"
						background={false}
						width={8}
						height={8}
						top="2rem"
					/>
				) : (
					remindersSorted.map((item) => (
						<Reminder key={item.id} reminder={item} toggle={toggle} />
					))
				)}
			</DrawerRPC>
		</>
	);
}
